import JobResults from './JobResults';

export default JobResults;
